import React from "react";
import { SvgIcon } from "@progress/kendo-react-common";
import * as svgIcons from "@progress/kendo-svg-icons";
import FastaSelectionForm from "@presentation/components/fasta/FastaSelectionForm";

import { useRequiredFieldState } from "../jobRequirements";
import { RequiredFieldNote } from "./RequiredFieldIndicators";

// Here we just import the FastaSelectionForm component and render it in the FastaFileFormBlock component
// Only thing we do here is some UI formatting
export const FastaFileFormBlock: React.FC = () => {
  // The requirement is a property of the job, not of the picker, so it is applied
  // here rather than inside FastaSelectionForm, which is a reusable component.
  const requiredState = useRequiredFieldState("fastaFiles");

  return (
    <fieldset className={"k-form-fieldset"}>
      <legend className={"k-form-legend"}>
        <strong>Fasta</strong> <SvgIcon style={{ paddingBottom: "5px" }} icon={svgIcons.fileDataIcon} />
      </legend>
      <FastaSelectionForm highlightAsIncomplete={requiredState.highlight} />
      <RequiredFieldNote state={requiredState}>Select at least one FASTA file to continue.</RequiredFieldNote>
    </fieldset>
  );
};
